import { render } from "./VariantFormModal.vue?vue&type=template&id=f7d9e988&scoped=true"
import script from "./VariantFormModal.vue?vue&type=script&lang=js"
export * from "./VariantFormModal.vue?vue&type=script&lang=js"

import "./VariantFormModal.vue?vue&type=style&index=0&id=f7d9e988&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7d9e988"]])

export default __exports__